import { Fragment, useEffect, useRef, useState } from 'react';

import { css } from '@compiled/react';

import { ufoEventLoomOnboardingTimeToView } from '@/components/signup/utils/ufo-events';
import { TypographyStyles } from '@/libraries/wpl/foundations/src/typography-styles';

import { AfterOnboardingStep } from './after-onboarding-step';
import { LoomOnboardingVariants } from './utilities/is-exp-loom-onboarding';
import { StepManager } from './utilities/step-manager';

const containerStyle = css({
	display: 'flex',
	flexFlow: 'column',
	alignItems: 'center',
	textAlign: 'center',
	paddingInline: '2rem',
});

export const LoomOnboardingView = () => {
	const [onboardingComplete, setOnboardingComplete] = useState(false);

	// Stop the "time-to-view" UFO timer that was started in `ProductViewSwitch`
	// when the LOOM confirmation view first mounted. Reaching this component
	// means the experiment is ON and the onboarding UI has rendered — the
	// counterpart stop for the OFF path lives in `use-cloud-status-redirection`
	// (right before the Loom SSO redirect).
	const timerStoppedRef = useRef(false);
	useEffect(() => {
		if (timerStoppedRef.current) {
			return;
		}
		timerStoppedRef.current = true;
		void ufoEventLoomOnboardingTimeToView.success({
			customData: {
				isExperimentLoomOnboardingToWac: true,
				loomOnboardingToWacVariant: LoomOnboardingVariants.VARIANT_1,
			},
		});
	}, []);

	const handleOnboardingComplete = () => {
		setOnboardingComplete(true);
	};

	return (
		<TypographyStyles>
			<Fragment>
				<div css={containerStyle} data-testid="loom-onboarding-view">
					{onboardingComplete ? (
						<AfterOnboardingStep />
					) : (
						<StepManager handleContinue={handleOnboardingComplete} />
					)}
				</div>
			</Fragment>
		</TypographyStyles>
	);
};

export default LoomOnboardingView;
